module.exports = __webpack_public_path__ + "static/media/fakturering_offerter_pinne.06e27b94.png";